import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { getSessionItem, removeSessionItem, setSessionItem } from '../config/runtimeConfig';

interface AuthState {
  token: string | null;
  isAuthenticated: boolean;
  login: (token: string) => void;
  logout: () => void;
  clearToken: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      isAuthenticated: false,
      login: (token: string) => set({ token, isAuthenticated: true }),
      logout: () => set({ token: null, isAuthenticated: false }),
      clearToken: () => set({ token: null, isAuthenticated: false }),
    }),
    {
      name: 'auth-storage',
      storage: {
        getItem: (name) => {
          const value = getSessionItem(name);
          return value ? JSON.parse(value) : null;
        },
        setItem: (name, value) => {
          setSessionItem(name, JSON.stringify(value));
        },
        removeItem: (name) => {
          removeSessionItem(name);
        },
      },
    }
  )
); 